export default "__VITE_ASSET__4b743d00__"